import { useEffect, useRef, type FC } from "react";
import { prefersReducedMotion } from "../../lib/motion";

/** Fixed top bar showing how far down the page the reader is. */
const ReadingProgress: FC = () => {
  const barRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (prefersReducedMotion()) return;
    // Lenis drives native scroll, so the window scroll event fires for it too.
    const update = () => {
      const max =
        document.documentElement.scrollHeight - window.innerHeight;
      const ratio = max > 0 ? Math.min(1, window.scrollY / max) : 0;
      if (barRef.current) barRef.current.style.transform = `scaleX(${ratio})`;
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  if (prefersReducedMotion()) return null;

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-x-0 top-0 z-[60] h-1"
    >
      <div
        ref={barRef}
        className="h-full origin-left bg-cyan-400"
        style={{ transform: "scaleX(0)" }}
      />
    </div>
  );
};

export default ReadingProgress;
